import styled from 'styled-components'

const FiveZeroZeroStyleWrapper = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: center;
  position: relative;

  @media only screen and (max-width: 767px) {
    flex-direction: column;
    flex-wrap: nowrap;
  }

  .iso500Content {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    flex-direction: column;

    @media only screen and (max-width: 767px) {
      order: 2;
      margin-top: 20px;
      align-items: center;
      text-align: center;
    }

    h1 {
      font-size: 84px;
      font-weight: 700;
      color: rgb(120, 129, 149);
      line-height: 1;
      margin: 0 0 25px;
    }

    h3 {
      font-size: 24px;
      font-weight: 400;
      color: rgb(89, 89, 89);
      margin: 0 0 10px;
      line-height: 1.2;
    }

    p {
      font-size: 14px;
      font-weight: 400;
      color: rgb(121, 121, 121);
      margin: 0 0 10px;
    }
  }

  img {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 100px;
    margin-right: 100px;
    height: 768px;

    @media only screen and (max-width: 767px) {
      margin-left: inherit;
      margin-right: 0;
    }

    img {
      max-height: 100%;
    }
  }
`

export default FiveZeroZeroStyleWrapper
